export default "__VITE_ASSET__D4fl2JPL__"